export default __webpack_public_path__ + "static/media/chain-1.fb803a46.png";